/* Run decorative loops only while their hero is visible and motion is welcome. */
(() => {
  if (window.__fizzyScienceFruitMotion) return;
  window.__fizzyScienceFruitMotion = true;
  const instances = new Map();
  function mount(root) {
    root.querySelectorAll('.sfh').forEach(hero => {
      if (instances.has(hero)) return;
      const preference = matchMedia('(prefers-reduced-motion: reduce)');
      let visible = false;
      function sync() {
        hero.dataset.motionRunning = String(visible && !document.hidden && !preference.matches);
      }
      const observer = new IntersectionObserver(entries => {
        visible = entries[0].isIntersecting;
        sync();
      }, { threshold: 0 });
      observer.observe(hero);
      preference.addEventListener('change', sync);
      document.addEventListener('visibilitychange', sync);
      // Scroll scale: 0 at the top, 1 once the hero has scrolled its own height away.
      let ticking = false;
      function onScroll() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          ticking = false;
          if (preference.matches) return;
          const rect = hero.getBoundingClientRect();
          const progress = Math.min(1, Math.max(0, -rect.top / (rect.height || 1)));
          hero.style.setProperty('--sfh-scroll', progress.toFixed(3));
        });
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      sync();
      onScroll();
      instances.set(hero, () => {
        observer.disconnect();
        preference.removeEventListener('change', sync);
        document.removeEventListener('visibilitychange', sync);
        window.removeEventListener('scroll', onScroll);
        instances.delete(hero);
      });
    });
  }
  mount(document);
  document.addEventListener('shopify:section:load', event => mount(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [hero, cleanup] of instances) if (event.target.contains(hero)) cleanup();
  });
})();
